import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { initSessionGuard } from "./lib/sessionGuard";
import "./index.css";

// Logga ut när webbläsaren stängts – måste köras före appen renderas.
initSessionGuard();


// Suppress WebSocket connection errors that occur during page load/audits
// These are automatic realtime connection attempts that may fail in audit environments
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const errorMessage = args[0]?.toString() || '';
  
  // Suppress WebSocket DNS resolution errors for realtime connections
  if (errorMessage.includes('WebSocket') && errorMessage.includes('ERR_NAME_NOT_RESOLVED')) {
    return;
  }
  
  originalConsoleError.apply(console, args);
};

// Suppress unhandled WebSocket errors from reaching the browser console
window.addEventListener('error', (event) => {
  if (event.message?.includes('WebSocket') || event.message?.includes('ERR_NAME_NOT_RESOLVED')) {
    event.preventDefault();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.toString() || '';
  if (reason.includes('WebSocket') || reason.includes('ERR_NAME_NOT_RESOLVED')) {
    event.preventDefault();
  }
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
